import { isPage } from '../utils/helpers.js';

// Widget Scripts
import vimeoFeature from '../widgets/vimeoFeature.js';
import imageTextCard from '../widgets/imageTextCard.js';
import cardWidget from '../widgets/cardWidget.js';
import scrollerSponsors from '../widgets/scrollerSponsors.js';

export function initWidgets() {
  if (isPage('fiber-fest-home')) {
    vimeoFeature(
      'fiberVimeoFeature',
      fiberVimeoFeatureOpts,
      'fiberSlideshow',
      fiberSlideshowOpts,
      'fiber-slideshow-wrapper',
    );
    imageTextCard('fiberImageTextCard1', fiberImageTextCard1Opts, { titleIsH1: true });
    cardWidget({
      widgetName: 'fiberCardWidget',
      widgetOpts: fiberCardWidgetOpts,
      wrapContainerClass: 'fiber-cardWidget-container-wrapper',
      showMoreButton: true,
      allLink: false,
    });
    scrollerSponsors('fiber-scroller-sponsors', fiberScrollerSponsorsOpts);
  }
}
